/* eslint-disable @typescript-eslint/no-empty-function */
import { SideBarContentType } from 'interfaces';
import { ReactChild } from 'react';

export type IHeaderContext = {
  isSearchListShown: boolean;
  hideSearchList: () => void;
  showSearchList: () => void;
  toggleSearchList: () => void;

  isSideBarOpen: boolean;
  sideBarContentType: SideBarContentType;
  openSideBar: () => void;
  closeSideBar: () => void;
  toggleSideBar: () => void;
  setSideBarType: (type: SideBarContentType) => void;

  isSearchIncorrect: boolean;
  setSearchedStatus: (val: boolean) => void;
};

export const initContext: IHeaderContext = {
  isSearchListShown: false,
  hideSearchList: () => {},
  showSearchList: () => {},
  toggleSearchList: () => {},

  isSideBarOpen: false,
  sideBarContentType: SideBarContentType.menu,
  openSideBar: () => {},
  closeSideBar: () => {},
  toggleSideBar: () => {},
  setSideBarType: (_) => {},

  isSearchIncorrect: true,
  setSearchedStatus: (_) => {},
};

export type HeaderContextProps = {
  children?: ReactChild;
};
